"use strict";
import { Path } from "react-art";
import relativeEventPosition from "./relative_event_position";
const utils = {
  diff(p1, p2) {
    return p1.subtract(p2);
  },
  direction(p1, p2) {
    return p2.subtract(p1).normalize();
  },
  distance(p1, p2) {
    return p1.subtract(p2);
  },
  // The cast is unavoidable: @types/react@0.14 declares `nativeEvent` as the base DOM
  // `Event`, so it carries no coordinates as far as the compiler is concerned. The
  // union at least pins down what callers may hand in.
  relMouseCoords(event, node) {
    const nativeEvent = "nativeEvent" in event ? event.nativeEvent : event;
    return relativeEventPosition(nativeEvent, node);
  },
  drawCenteredCircle(p, radius) {
    const offset = {
      x: radius,
      y: 0
    };
    const [p1, p2] = [p.subtract(offset), p.add(offset)];
    return utils.drawCircle(p1, p2);
  },
  drawCircle(p1, p2) {
    const v = utils.diff(p1, p2);
    const radius = v.length() / 2;
    return new Path().moveTo(p1.x, p1.y).arc(-v.x, -v.y, radius, radius).arc(v.x, v.y, radius, radius).close();
  },
  Colors: {
    transparent: "rgba(0,0,0,0)"
  }
};
export default utils;
